import { request } from './_core'
import { AuthUser } from './auth'

// ── Users ─────────────────────────────────────────────────────

export interface UserStats {
  today:      number
  streak:     number
  best:       number | null
  percentile: number | null
}

export interface FullUser extends AuthUser {
  preferredLanguage: string
  subscriptionStatus: string
  createdAt: string
}

export const users = {
  me:    ()                              => request<FullUser>('/users/me'),
  stats: ()                              => request<UserStats>('/users/me/stats'),
  update: (data: { displayName?: string; preferredLanguage?: string }) =>
    request<AuthUser>('/users/me', { method: 'PATCH', body: JSON.stringify(data) }),
}

// ── Admin Users ───────────────────────────────────────────────

export interface AdminUserSummary {
  id:                 string
  email:              string
  displayName:        string | null
  role:               'USER' | 'ADMIN'
  tier:               'BASIC' | 'PLUS' | 'PREMIUM'
  subscriptionStatus: string
  preferredLanguage:  string
  flaggedMultiIp:     boolean
  flaggedAt:          string | null
  createdAt:          string
}

export interface AdminUserDetail extends AdminUserSummary {
  emailVerified:         boolean
  subscriptionIsActive:  boolean
  subscriptionStartsAt:  string | null
  subscriptionExpiresAt: string | null
  stripeCustomerId:      string | null
  stripeSubscriptionId:  string | null
  gameSessionCount:      number
  lastSessionAt:         string | null
  updatedAt:             string
}

export interface AdminLoginSession {
  id:          string
  ip:          string
  userAgent:   string | null
  createdAt:   string
  lastSeenAt:  string
  expiresAt:   string
}

export const adminUsers = {
  list: (email?: string, flaggedOnly?: boolean) => {
    const params = new URLSearchParams()
    if (email)       params.set('email', email)
    if (flaggedOnly) params.set('flaggedOnly', 'true')
    const qs = params.toString() ? `?${params.toString()}` : ''
    return request<AdminUserSummary[]>(`/users/admin/list${qs}`)
  },
  get:       (id: string) => request<AdminUserDetail>(`/users/admin/${id}`),
  sessions:  (id: string) => request<AdminLoginSession[]>(`/users/admin/${id}/sessions`),
  clearFlag: (id: string) => request<{ ok: boolean }>(`/users/admin/${id}/clear-flag`, { method: 'PATCH' }),
}
